import { render, staticRenderFns } from "./IconDatumKalender.vue?vue&type=template&id=bd503390&scoped=true"
import script from "./IconDatumKalender.vue?vue&type=script&lang=ts"
export * from "./IconDatumKalender.vue?vue&type=script&lang=ts"
import style0 from "./IconDatumKalender.vue?vue&type=style&index=0&id=bd503390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd503390",
  null
  
)

export default component.exports